import { AccountTab } from "@/components/user-record/account-tab";
import { useCurrentUser } from "@/lib/api/user";
import { Skeleton } from "@somethings-ui/web";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile/account")({
  component: ProfileAccountPage,
});

function ProfileAccountPage() {
  const { data: user } = useCurrentUser();

  if (!user) {
    return <Skeleton className="h-40 w-full" />;
  }

  return <AccountTab user={user} surface="self" />;
}
